import React from "react";
import "./azure-login.css";
import { API_AUTH } from "../../utils/authentication";
import { FormattedMessage } from "react-intl";

const AZURE_ROOT_URL = "https://login.microsoftonline.com";

const AzureLogin = ({ tenantId, clientId, scope }) => {
 const url =
  `${AZURE_ROOT_URL}/${tenantId}/oauth2/v2.0/authorize?` +
  `client_id=${clientId}` +
  "&response_type=code" +
  "&response_mode=query" +
  `&redirect_uri=${API_AUTH.COMMON_AUTH_V1}${API_AUTH.AUTHORIZATION_CODE_ENDPOINT}` +
  `&scope=${scope}` +
  `&state=134555`;

 return (
  <button
   className="microsoft-sign-in"
   onClick={() => (window.location.href = url)}>
   <svg
    width="20"
    height="20"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
   </svg>
   <span>
    <FormattedMessage id="signInWithMicrosoft" />
   </span>
  </button>
 );
};

export default AzureLogin;
